// extracted by mini-css-extract-plugin
export var dropdownContainer = "_rr-0";
export var leftAlign = "_rr-4";
export var listItem = "_rr-2";
export var listItemWrapper = "_rr-1";
export var operationText = "_rr-3";